import { Action, createReducer, on } from "@ngrx/store";
import { NotificationInfo } from "@uzurv/clara";

import * as userActions from './user.actions';
import { AuthenticatedUser } from "@uzurv/http";

export const userFeatureKey = 'user'

export interface UserState {
  user: AuthenticatedUser;
  notifications: Array<NotificationInfo>;
}

export const initialState: UserState = {
  user: null,
  notifications: null
}

const reducer = createReducer(
  initialState,

  on(userActions.loginSuccess, (state, payload) => ({ ...state, user: payload.user })),

  on(userActions.listNotificationsSuccess, (state, payload) => ({ ...state, notifications: payload.notifications })),
);

export function userReducer(state: UserState | undefined, action: Action) {
  return reducer(state, action);
}
